import React from 'react';
import Icon from './Icon';
import {Wrapper, Text, IconWrapper, Image} from '../styles';
import appConfig from '../../../../app-config';
import truncateMessage from '../utils/truncateMessage';

const OrderRefunded = ({orderStatus, ignoreTruncateMessage}) => {
  return (
    <Wrapper>
      <IconWrapper>
        {appConfig.orderStatusImages &&
        appConfig.orderStatusImages.order_refunded ? (
          <Image src={appConfig.orderStatusImages.order_refunded} />
        ) : (
          <Icon
            className={
              (appConfig.orderStatusIcons &&
                appConfig.orderStatusIcons.order_refunded) ||
              'fas fa-exclamation-triangle'
            }
          />
        )}
      </IconWrapper>
      <Text>
        {orderStatus.status_change_message == 'Order status has changed'
          ? 'Unfortunately, we cannot process your order at this time'
          : truncateMessage(
              orderStatus.status_change_message || '',
              ignoreTruncateMessage
            )}
      </Text>
    </Wrapper>
  );
};

export default OrderRefunded;
